import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "exit",
  "use": "exit-usage",
  "viewBox": "0 0.999 18.988 17",
  "content": "<symbol viewBox=\"0 0.999 18.988 17\" id=\"exit\"><path d=\"M11.17 12.057h1v5.942H0v-17h12.17v5.308h-1V1.999H1v15h10.17v-4.942zm5.277-5.728l-.707.707 1.34 1.34-11.395.056.005 1 11.377-.056-1.452 1.453.707.707 2.666-2.666-2.541-2.541z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/exit.svg
// module id = 161
// module chunks = 0